import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SystemService } from '../system/system.service';
import { IamCoreService } from '../../module/iam/iam-core.service';

export const requireRolesOrAdminGuard: CanActivateFn = (route, state) => {
    const systemService = inject(SystemService);
    const iamCoreService = inject(IamCoreService);
    const router = inject(Router);

    return systemService.watchInitialized().pipe(
        map(() => {
            if (!systemService.getLocalStorage('token') || !systemService.getUser()) {
                return router.createUrlTree(['/iam/sign/in'], { queryParams: { redirect: state.url } });
            }

            const roles = (route.data['roles'] ?? []) as string[];
            const hasAccess = iamCoreService.hasRoleOrMaster()
                || roles.some(role => iamCoreService.hasRoleOrMaster(role));

            return hasAccess
                ? true
                : router.createUrlTree(['/error'], { fragment: '403' });
        })
    );
};
